import { Box, useTheme, Typography } from "@mui/material";

import ArrowForwardIcon from "@mui/icons-material/ArrowForward";

import profile_banner from "../../Assets/images/Caterertop.png";

const BannerImage = ({ path }) => {
  const theme = useTheme();
  return (
    <Box
      sx={{
        position: "relative",
        height: { xs: "200px", sm: "300px", md: "40vh" },
      }}
    >
      <Box sx={{ height: "100%" }}>
        <img
          loading="eager"
          style={{
            width: "100%",
            height: "100%",
            objectFit: "cover",
          }}
          src={profile_banner}
          alt="preview"
        />{" "}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            bgcolor: "rgba(0, 0, 0, 0.3)",
            borderRadius: "inherit",
          }}
        />
      </Box>
      <Box
        sx={{
          color: theme.palette.text.defaultLight,
          position: "absolute",
          zIndex: 1,
          top: "50%",
          left: "50%",
          transform: "translate(-50%, -50%)",
        }}
      >
        <Typography
          sx={{
            color: theme.palette.text.defaultLight,
            fontSize: { xs: "24px", lg: "34px", md: "48px" },
            textAlign: "center",
            textTransform: "uppercase",
            fontFamily: `Snugle !important`,
          }}
          className="fontSnugle"
        >
          {path.title}
        </Typography>
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            gap: 1,
            justifyContent: "center",
          }}
        >
          <Typography
            sx={{
              textAlign: "center",
              color: theme.palette.text.defaultLight,
              fontSize: { xs: "14px", lg: "24px", md: "28px" },
            }}
          >
            {path.home}
          </Typography>
          <ArrowForwardIcon sx={{ color: theme.palette.text.defaultLight }} />{" "}
          <Typography
            sx={{
              textAlign: "center",
              color: theme.palette.text.defaultLight,
              fontSize: { xs: "14px", lg: "24px", md: "28px" },
            }}
          >
            {path.nav}
          </Typography>
        </Box>
      </Box>
    </Box>
  );
};

export default BannerImage;
